import styled from 'styled-components';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { fontWeight } from '@whitelabel/helpers/style/type';

export const StyledCollapse = styled.div<{ $isOpen: boolean }>`
  width: max(100vw, 100%);
  z-index: 1000;
  background: ${themeColor('tertiaryBg')};
  height: calc(100vh - 2rem);
  padding: 1rem;
  position: absolute;
  top: 0;
  transition: left 1s, visibility 1s;
  left: ${({ $isOpen }) => ($isOpen ? '0' : 'max(100vw, 100%)')};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};

  @media print {
    display: none;
  }
`;

export const StyledScrollableContainer = styled.div`
  overflow-y: scroll;
  background-color: inherit;
  height: calc(100vh - 12rem);
  width: 100%;
  h1 {
    color: ${themeColor('heading')};
  }
  .nav-settings-submenu {
    font-weight: ${fontWeight('black')};
  }
`;

export const StyledNavCustomer = styled.div`
  .customer-data {
    margin-bottom: 1rem;
  }
`;
